import { render, staticRenderFns } from "./OutboundShipments.vue?vue&type=template&id=a2c620ac&scoped=true"
import script from "./OutboundShipments.vue?vue&type=script&lang=js"
export * from "./OutboundShipments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c620ac",
  null
  
)

export default component.exports